(function(){
  var MXN=function(n){return "$"+n.toLocaleString("es-MX",{minimumFractionDigits:2,maximumFractionDigits:2})+" MXN"};
  var PESOS=function(n){return "$"+n.toLocaleString("es-MX")};
  var SHORT=function(n){return "$"+n.toLocaleString("es-MX",{minimumFractionDigits:2,maximumFractionDigits:2})};

  var OILS=window.__MALI.oils;
  var FPS=window.__MALI.fps;
  var AFTER=window.__MALI.after;
  var OFFERS=window.__MALI.offers.filter(Boolean).filter(function(o){return o&&o.vid&&o.available!==false});
  var GIFT_MIN=window.__MALI.giftMin, GIFT_VALUE=window.__MALI.giftValue;
  var SHIP_MIN=+window.__MALI.shipMin||1, SHIP_MAX=+window.__MALI.shipMax||5, SHOW_SHIP=!!window.__MALI.showShip;
  var RULES=window.__MALI.rules||{on:false};

  /* ---------- motor de precios ----------
     Cada oferta (producto suelto o kit) cubre uno o más componentes. Buscamos la
     combinación de ofertas REALES más barata que cubra exactamente la selección.
     Así nunca mandamos al carrito un ID que no exista: sólo se usa lo que Shopify
     devolvió como disponible al renderizar la página. */
  var KEYS=["carrot","watermelon","cacao","sun","fps","after"];
  function maskOf(list){
    var m=0;
    list.forEach(function(k){ var i=KEYS.indexOf(k); if(i>-1) m|=(1<<i); });
    return m;
  }
  OFFERS.forEach(function(o){ o.mask=maskOf(o.covers); });

  var SINGLE={};
  OFFERS.forEach(function(o){ if(o.covers.length===1 && (!SINGLE[o.covers[0]]||o.price<SINGLE[o.covers[0]].price)) SINGLE[o.covers[0]]=o; });

  var planCache={};
  function bestPlan(mask){
    if(planCache[mask]!==undefined) return planCache[mask];
    var dp={0:0}, from={};
    for(var m=0;m<=mask;m++){
      if((m&mask)!==m) continue;
      if(dp[m]===undefined) continue;
      for(var i=0;i<OFFERS.length;i++){
        var o=OFFERS[i];
        if((o.mask&mask)!==o.mask) continue;   /* no puede traer algo no elegido */
        if(o.mask & m) continue;               /* sin traslapes */
        var nm=m|o.mask, np=dp[m]+o.price;
        if(dp[nm]===undefined||np<dp[nm]-1e-9){ dp[nm]=np; from[nm]={prev:m,offer:o}; }
      }
    }
    var res=null;
    if(dp[mask]!==undefined){
      var items=[], cur=mask;
      while(cur){ var f=from[cur]; items.push(f.offer); cur=f.prev; }
      res={price:Math.round(dp[mask]*100)/100, items:items.reverse()};
    }
    planCache[mask]=res;
    return res;
  }
  function keysOf(s){ return s.oils.concat(s.fps?["fps"]:[]).concat(s.after?["after"]:[]); }
  function listPrice(keys){
    return keys.reduce(function(a,k){ return a+(SINGLE[k]?SINGLE[k].price:0); },0);
  }
  function planOf(s){ return bestPlan(maskOf(keysOf(s))); }
  /* ¿el componente viene dentro de un kit (oferta multi-producto) en este plan? */
  function inBundle(plan,key){
    return !!(plan&&plan.items.some(function(o){return o.covers.length>1&&o.covers.indexOf(key)>-1}));
  }

  /* ---------- descuento por rutina (reglas del cliente) ----------
     1 aceite + After Sun 10% · 1 aceite + FPS 15% · 2+ aceites 15%
     2+ aceites + FPS 20% · rutina completa (aceite + FPS + After Sun) 25%
     2+ aceites + After Sun no esta en la tabla: se queda en el 15% de "2 aceites",
     porque agregar un producto nunca debe bajar el descuento. */
  function pctFor(s){
    var n=s.oils.length;
    if(!RULES.on||n<1) return 0;
    if(s.fps&&s.after) return +RULES.full||0;
    if(s.fps) return n>=2 ? (+RULES.oilsFps||0) : (+RULES.oilFps||0);
    if(n>=2) return +RULES.twoOils||0;
    if(s.after) return +RULES.oilAfter||0;
    return 0;
  }
  /* Cotizacion unica para pantalla y carrito: lo que se muestra es lo que se cobra.
     Con reglas activas se agregan los productos sueltos y Shopify aplica el codigo
     (prefijo + %), redondeando por linea como lo hace el checkout. */
  var forzarKits=false;   /* respaldo si Shopify no aplica el codigo */
  function quote(s){
    var keys=keysOf(s), list=listPrice(keys);

    /* opcion A: los kits reales de la tienda */
    var plan=bestPlan(maskOf(keys)), kitQ=null;
    if(plan){
      var kit=(plan.items.filter(function(o){return o.covers.length>1})[0]||{}).name||null;
      kitQ={list:list,total:plan.price,pct:0,items:plan.items,code:null,
            label:kit?("Ahorro con "+kit):"Descuento por armar tu rutina",plan:plan};
    }
    if(!RULES.on||forzarKits) return kitQ;

    /* opcion B: productos sueltos con el % de la regla (lo cobra el codigo en Shopify) */
    var items=[], ok=true;
    for(var i=0;i<keys.length;i++){ if(!SINGLE[keys[i]]){ ok=false; break; } items.push(SINGLE[keys[i]]); }
    var ruleQ=null;
    if(ok){
      var pct=pctFor(s), cents=0;
      /* Shopify trunca el descuento de cada linea hacia abajo (207.90 al 25% descuenta
         51.97, no 51.98). Redondeando se mostraba un centavo menos del que se cobra. */
      items.forEach(function(o){ var c=Math.round(o.price*100); cents+=c-Math.floor((c*pct)/100+1e-6); });
      ruleQ={list:list,total:cents/100,pct:pct,items:items,
             code:pct>0?(RULES.prefix+pct):null,
             label:pct>0?("Descuento por tu rutina ("+pct+"%)"):null};
    }
    /* Se cobra lo mas barato para la clienta: nunca mas caro que un kit que la tienda
       ya vende, nunca menos descuento del que prometen las reglas. */
    if(!ruleQ) return kitQ;
    if(!kitQ)  return ruleQ;
    return (kitQ.total < ruleQ.total-0.009) ? kitQ : ruleQ;
  }

  /* % que se muestra. Si gana la regla se muestra el % prometido (el truncado por
     linea de Shopify lo deja en 24.9997%, y "24% OFF" contradecia la etiqueta).
     Si gana un kit, se calcula el real hacia abajo para no prometer de mas. */
  function effPct(q){
    if(!q||!q.list) return 0;
    if(q.pct>0) return q.pct;
    return Math.floor(((q.list-q.total)/q.list)*100+1e-9);
  }

  var state={oils:["carrot"],fps:true,after:false,hero:"carrot"};

  /* galería: mismos slots de foto que las tarjetas */
  var GAL=window.__MALI.gallery;

  function renderGallery(){
    var g=GAL.filter(function(x){return x.id===state.hero})[0]||GAL[0];
    document.getElementById("galMain").className="gal-main "+(g.res||g.shot);
    document.getElementById("galName").textContent=g.name;
    document.getElementById("galTone").textContent=g.sub;
    document.getElementById("galThumbs").innerHTML=GAL.map(function(x){
      return '<button type="button" class="thumb '+(x.res||x.shot)+(x.id===state.hero?" on":"")+'" data-hero="'+x.id+'" '
        +'aria-label="Ver '+x.name+'" aria-pressed="'+(x.id===state.hero)+'"></button>';
    }).join("");
    var sb=document.getElementById("sbThumb");
    if(sb) sb.className="sb-thumb "+g.shot;
  }
  var CHECK='<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1.5 6.2l3 3 6-6.4" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Fila compacta: 4 aceites caben en una pantalla en vez de exigir scroll por cada uno. */
  function oilCard(o){
    var on=state.oils.indexOf(o.id)>-1, out=o.available===false;
    var flag = out ? '<span class="flag out">Agotado</span>'
             : (typeof o.stock==="number"&&o.stock>0&&o.stock<20
                ? '<span class="flag">Quedan '+o.stock+'</span>' : '');
    return '<div class="opt-row'+(on?" on":"")+(out?" sold":"")+'" role="checkbox" tabindex="'+(out?-1:0)+'" '
      +'aria-checked="'+on+'" aria-disabled="'+out+'" '+(out?'':'data-oil="'+o.id+'"')+'>'
      +'<span class="opt-figure '+o.shot+'"></span>'
      +'<span class="opt-main">'
        +'<span class="opt-head"><span class="tag">'+o.tag+'</span></span>'
        +'<span class="nm">'+o.name+'</span>'
        +'<span class="tone-line">'+o.tone+'</span>'
        +'<span class="ds">'+o.ds+'</span>'
      +'</span>'
      +'<span class="opt-side">'
        +'<span class="check">'+CHECK+'</span>'
        +'<span class="pr">'+PESOS(o.price)+'</span>'
        +flag
      +'</span></div>';
  }
  function addonCard(it,on,key,rec){
    var out=it.available===false;
    return '<div class="addon'+(on?" on":"")+(out?" sold":"")+'" role="checkbox" tabindex="'+(out?-1:0)+'" '
      +'aria-checked="'+on+'" aria-disabled="'+out+'" '+(out?'':'data-add="'+key+'"')+'>'
      +'<span class="mini '+it.mini+'"></span>'
      +'<span class="body"><span class="nm">'+it.name+'</span><span class="ds">'+it.ds+'</span></span>'
      +'<span class="right">'+(out?'<span class="rec sold-tag">Agotado</span>':(rec?'<span class="rec">Recomendado</span>':''))
      +'<span class="check">'+CHECK+'</span>'
      +'<span class="pr">'+SHORT(it.price)+'</span></span></div>';
  }

  function render(){
    document.getElementById("oils").innerHTML=OILS.map(oilCard).join("");
    document.getElementById("fpsSlot").innerHTML=addonCard(FPS,state.fps,"fps",true);
    document.getElementById("afterSlot").innerHTML=addonCard(AFTER,state.after,"after",false);

    var keys=keysOf(state);
    var q=quote(state);
    var sub=listPrice(keys);
    var total=q?q.total:sub;
    var save=Math.round((sub-total)*100)/100;

    function setBadge(el,txt,active){
      var b=document.getElementById(el);
      if(!txt){ b.hidden=true; return; }
      b.className="stepsave"+(active?" active":""); b.textContent=txt; b.hidden=false;
    }
    function withKey(key,val){ var t={oils:state.oils.slice(),fps:state.fps,after:state.after}; t[key]=val; return t; }

    if(RULES.on){
      /* Upsell por escalones: cada paso dice a cuanto sube el descuento si lo agregas */
      var pct=effPct(q);
      if(pct>0) setBadge("save1",pct+"% OFF",true);
      else if(state.oils.length===1&&(+RULES.twoOils||0)>0) setBadge("save1","2 aceites: "+RULES.twoOils+"% OFF",false);
      else setBadge("save1",null);
      [["save2","fps",FPS],["save3","after",AFTER]].forEach(function(b){
        if(state[b[1]]){ setBadge(b[0], pct>0?("Sumando al "+pct+"% OFF"):null, true); return; }
        if(b[2].available===false){ setBadge(b[0],null); return; }
        var p2=effPct(quote(withKey(b[1],true)));
        setBadge(b[0], p2>pct?("Agrégalo: "+p2+"% OFF"):null, false);
      });
    }else{
      /* Kits: "incluido en tu kit", o cuanto ahorra si lo agrega */
      var plan=q&&q.plan;
      setBadge("save1", save>0.5?("Ahorras "+SHORT(save)):null, true);
      [["save2","fps",FPS],["save3","after",AFTER]].forEach(function(b){
        if(state[b[1]]){ setBadge(b[0], inBundle(plan,b[1])?"Incluido en tu kit":null, true); return; }
        if(b[2].available===false||!q){ setBadge(b[0],null); return; }
        var q2=quote(withKey(b[1],true));
        var ahorro=q2?Math.round(((q.total+b[2].price)-q2.total)*100)/100:0;
        setBadge(b[0], ahorro>0.5?("Agrégalo y ahorra "+SHORT(ahorro)):null, false);
      });
    }

    document.getElementById("sub").textContent=MXN(sub);
    document.getElementById("saveLabel").textContent=(q&&q.label)||"Descuento por armar tu rutina";
    document.getElementById("save").textContent="− "+MXN(save);
    document.getElementById("saveLine").hidden=save<=0.5;
    document.getElementById("grand").textContent=MXN(total);
    var st=document.getElementById("strike");
    st.hidden=save<=0.5; st.textContent=save>0.5?MXN(sub):"";

    var falta=GIFT_MIN-total, gift=document.getElementById("gift");
    document.getElementById("giftBar").style.width=Math.min(100,(total/GIFT_MIN)*100).toFixed(1)+"%";
    var giftLine=document.getElementById("giftLine");
    if(falta<=0){
      gift.classList.add("unlocked");
      document.getElementById("giftTxt").innerHTML="<b>Glossy Drops desbloqueado</b> — gloss con FPS 30, valor "+PESOS(GIFT_VALUE)+".<br>Se agrega solo al llegar a tu carrito.";
      giftLine.hidden=false;
    }else{
      gift.classList.remove("unlocked");
      document.getElementById("giftTxt").innerHTML="Te faltan <b>"+MXN(falta)+"</b> para llevarte los <b>Glossy Drops</b> de regalo — gloss con FPS 30, valor "+PESOS(GIFT_VALUE)+".";
      giftLine.hidden=true;
    }

    /* barra fija */
    var n=keys.length;
    document.getElementById("sbLabel").textContent=n+(n===1?" producto":" productos");
    document.getElementById("sbTotal").textContent=SHORT(total);
    var sbs=document.getElementById("sbStrike");
    sbs.hidden=save<=0.5; sbs.textContent=save>0.5?SHORT(sub):"";

    var ok=!!q;
    [document.getElementById("cta"),document.getElementById("sbCta")].forEach(function(b){ if(b) b.disabled=!ok; });
    if(!ok) showError("Alguno de los productos que elegiste no está disponible. Quita ese y elige otro para continuar.");
    else hideError();

    renderGallery();
    showRoutine();
  }

  /* ---------- carrito ---------- */
  var errEl=document.getElementById("ctaError");
  function showError(msg){ if(!errEl)return; errEl.textContent=msg; errEl.hidden=false; }
  function hideError(){ if(!errEl)return; errEl.hidden=true; errEl.textContent=""; }

  /* Esta tienda usa cajon de carrito (cart_type: drawer) y tiene la app UpCart,
     que engancha fetch y abre su cajon sola al detectar un add. Si el cajon aparece,
     no navegamos: mandar ademas a /cart duplica el flujo. Si no hay cajon, /cart
     es el respaldo, que es donde se aplica el regalo y la clienta revisa su pedido. */
  /* Detectar el cajon por clase no sirve: UpCart le pone una clase al contenedor de
     la pagina, asi que "[class*=upcart]" daba positivo aunque no hubiera cajon.
     Se mira si hay algo encima de la landing en el centro de la pantalla. */
  function cartUiOpened(){
    try{
      var el=document.elementFromPoint(Math.round(window.innerWidth/2),
                                       Math.round(window.innerHeight/2));
      if(!el||el===document.body||el===document.documentElement) return false;
      return !el.closest(".mali-solar");
    }catch(e){ return false; }
  }
  function releaseBtn(btn,label){
    adding=false;
    btn.classList.remove("loading"); btn.disabled=false; btn.textContent=label;
  }
  function afterAdd(btn,label){
    ["cart:refresh","cart:build","cart:updated","ajaxProduct:added"].forEach(function(ev){
      try{ document.documentElement.dispatchEvent(new CustomEvent(ev,{bubbles:true})); }catch(e){}
    });
    setTimeout(function(){
      /* Si el cajon de carrito se abrio (UpCart), ahi se queda: muestra el pedido,
         la barra del regalo y el boton de finalizar. Navegar a /cart lo reemplazaria. */
      if(cartUiOpened()){ releaseBtn(btn,label); return; }
      window.location.href="/cart";
    },1200);
  }

  /* ---------- codigo de la rutina ----------
     Deja en el carrito solo el codigo que corresponde a la rutina actual: quita los
     codigos viejos de rutina (mismo prefijo) y respeta cualquier otro que la clienta
     ya tuviera. La API del carrito de esta tienda acepta "discount" (verificado). */
  function jget(url){
    return fetch(url,{headers:{"Accept":"application/json"}})
      .then(function(r){return r.text()})
      .then(function(t){ try{return JSON.parse(t)}catch(e){return null} })
      .catch(function(){return null});
  }
  function syncCode(code,forzar){
    if(!RULES.on) return Promise.resolve();
    var pre=String(RULES.prefix||"").toUpperCase();
    return jget("/cart.js").then(function(cart){
      var cur=((cart&&cart.discount_codes)||[]).map(function(d){return String(d.code)});
      var keep=cur.filter(function(c){ return !pre||c.toUpperCase().indexOf(pre)!==0; });
      var want=keep.concat(code?[code]:[]);
      var same=want.length===cur.length&&want.every(function(c){return cur.indexOf(c)>-1});
      if(same&&!forzar) return;
      return fetch("/cart/update.js",{method:"POST",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({discount:want.join(",")})}).catch(function(){});
    });
  }
  function esperar(ms){ return new Promise(function(r){ setTimeout(r,ms); }); }
  function postJSON(path,payload){
    return fetch(path,{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify(payload)})
      .then(function(r){ return r.text().then(function(t){
        var d=null; try{ d=JSON.parse(t); }catch(e){}
        return {ok:r.ok,status:r.status,data:d}; }); });
  }
  /* Un 429 o una respuesta no-JSON casi siempre es momentaneo: se reintenta una vez
     antes de molestar a la clienta con un error. */
  function agregarItems(items,reintento){
    return postJSON("/cart/add.js",{items:items}).then(function(res){
      if(res.ok&&res.data) return res;
      if(!reintento&&(res.status===429||!res.data)) return esperar(1800).then(function(){ return agregarItems(items,true); });
      return res;
    });
  }
  /* Confirma que Shopify aplico el codigo, reintentando antes de rendirse. */
  function aplicarCodigo(code,intento){
    if(!code) return Promise.resolve(true);
    return syncCode(code,true).then(function(){ return jget("/cart.js"); }).then(function(cart){
      if(!cart||!Array.isArray(cart.discount_codes)) return true;  /* no se pudo leer: no alarmar */
      var ok=cart.discount_codes.some(function(d){
        return String(d.code).toUpperCase()===code.toUpperCase()&&d.applicable!==false; });
      if(ok) return true;
      if((intento||0)<2) return esperar(900).then(function(){ return aplicarCodigo(code,(intento||0)+1); });
      return false;
    });
  }
  /* Si el codigo no se pudo aplicar, se cobra con los kits reales de la tienda:
     la clienta SIEMPRE termina su compra en la web y paga lo que ve en pantalla.
     Solo se quitan las lineas que acabamos de agregar, no el resto de su carrito. */
  function respaldoKits(btn,label,agregados){
    forzarKits=true;
    render();
    var k=quote(state), counts={};
    (k&&k.items||[]).forEach(function(o){ counts[o.vid]=(counts[o.vid]||0)+1; });
    var quitar={};
    agregados.forEach(function(it){ quitar[it.id]=0; });
    return postJSON("/cart/update.js",{updates:quitar,discount:""})
      .then(function(){
        return agregarItems(Object.keys(counts).map(function(id){
          return {id:parseInt(id,10),quantity:counts[id]}; }));
      })
      .then(function(){ afterAdd(btn,label); });
  }

  var adding=false;
  function addToCart(btn){
    if(adding) return;
    var q=quote(state);
    if(!q||!q.items.length){ showError("No pudimos armar tu rutina. Recarga la página e inténtalo de nuevo."); return; }
    adding=true; hideError();
    var label=btn.textContent;
    btn.classList.add("loading"); btn.disabled=true; btn.textContent="Agregando…";

    var counts={};
    q.items.forEach(function(o){ counts[o.vid]=(counts[o.vid]||0)+1; });
    var items=Object.keys(counts).map(function(id){ return {id:parseInt(id,10),quantity:counts[id]}; });

    agregarItems(items)
    .then(function(res){
      if(!res.ok||!res.data){
        var m;
        if(res.status===429) m="La tienda está recibiendo muchas solicitudes. Espera unos segundos y vuelve a intentarlo.";
        else if(res.data&&(res.data.description||res.data.message)) m=res.data.description||res.data.message;
        else if(res.status>=500) m="La tienda no respondió. Inténtalo de nuevo en un momento.";
        else m="No pudimos agregar tu rutina al carrito. Inténtalo de nuevo.";
        throw new Error(m);
      }
      if(!q.code){ afterAdd(btn,label); return; }
      return aplicarCodigo(q.code).then(function(ok){
        if(ok){ afterAdd(btn,label); return; }
        return respaldoKits(btn,label,items);
      });
    })
    .catch(function(err){
      adding=false;
      btn.classList.remove("loading"); btn.disabled=false; btn.textContent=label;
      var m=(err&&err.message)?err.message:"";
      /* nunca enseñar errores técnicos del navegador */
      if(!m||/JSON|token|undefined|NetworkError|Failed to fetch/i.test(m))
        m="No pudimos agregar tu rutina al carrito. Revisa tu conexión e inténtalo de nuevo.";
      showError(m);
      var c=document.getElementById("ctaError");
      if(c) c.scrollIntoView({behavior:"smooth",block:"center"});
    });
  }
  document.getElementById("cta").addEventListener("click",function(){ addToCart(this); });
  document.getElementById("sbCta").addEventListener("click",function(){ addToCart(this); });

  /* ---------- barra fija de compra ---------- */
  (function(){
    var bar=document.getElementById("stickyBar"),
        cta=document.getElementById("cta"),
        sentinel=document.getElementById("stickySentinel");
    if(!bar||!cta||!sentinel||!("IntersectionObserver" in window)) return;
    var passed=false, ctaVisible=false, nudged=[];

    /* Los botones flotantes de apps (WhatsApp, Privy, chat...) quedarían encima de
       la barra. En vez de listar clases de apps, se detecta lo que realmente estorba:
       se mira qué hay debajo de las esquinas inferiores y se sube su contenedor fijo.
       Así sigue funcionando aunque la tienda cambie de app. */
    function fixedRoot(el){
      while(el&&el.nodeType===1&&el!==document.body){
        var s=window.getComputedStyle(el);
        if(s.position==="fixed"){
          var r=el.getBoundingClientRect();
          /* solo widgets pequeños: nunca barras u overlays de ancho completo */
          return (r.width<=190&&r.height<=190)?el:null;
        }
        el=el.parentElement;
      }
      return null;
    }
    function floaters(){
      var vh=window.innerHeight, vw=window.innerWidth, out=[];
      function add(el){
        if(!el||out.indexOf(el)>-1) return;
        if(el.closest&&el.closest(".mali-solar")) return;
        out.push(el);
      }
      var pts=[[18,vh-18],[vw-18,vh-18],[18,vh-70],[vw-18,vh-70],[vw/2,vh-18]];
      pts.forEach(function(pt){
        var stack=[];
        try{ stack=document.elementsFromPoint(pt[0],pt[1])||[]; }catch(e){}
        for(var i=0;i<stack.length;i++){
          var el=stack[i];
          if(el.closest&&el.closest(".mali-solar")) continue;
          add(fixedRoot(el));
        }
      });
      /* respaldo: widgets colgados directamente del body que no cayeron en los puntos */
      try{
        document.querySelectorAll("body > div, body > a, body > aside").forEach(function(el){
          if(el.closest(".mali-solar")) return;
          var s=window.getComputedStyle(el);
          if(s.position!=="fixed"||s.display==="none") return;
          var r=el.getBoundingClientRect();
          if(r.width<30||r.width>190||r.height<30||r.height>190) return;
          if(r.bottom>vh+10||r.bottom<vh-230) return;
          add(el);
        });
      }catch(e){}
      return out;
    }
    function nudge(on){
      if(on){
        nudged=floaters();
        nudged.forEach(function(el){
          el.dataset.maliPrevTransform=el.style.transform||"";
          el.style.transition="transform .2s ease";
          el.style.transform="translateY(-"+(bar.offsetHeight+8)+"px)";
        });
      }else{
        nudged.forEach(function(el){ el.style.transform=el.dataset.maliPrevTransform||""; });
        nudged=[];
      }
    }
    function sync(){
      var show=passed&&!ctaVisible;
      if(show===!bar.hidden) return;
      bar.hidden=!show;
      document.documentElement.classList.toggle("mali-sticky-on",show);
      if(show) document.documentElement.style.setProperty("--mali-sticky-h",bar.offsetHeight+"px");
      nudge(show);
    }
    new IntersectionObserver(function(e){ ctaVisible=e[0].isIntersecting; sync(); },{threshold:0}).observe(cta);
    new IntersectionObserver(function(e){
      passed=!e[0].isIntersecting&&e[0].boundingClientRect.top<0;
      sync();
    },{threshold:0}).observe(sentinel);
  })();

  /* ---------- planificador ---------- */
  function plan(prepDays,tripDays){
    var before=[],during=[],min=10;
    for(var d=1;d<=Math.min(prepDays,6);d++){
      if(d<=3){
        before.push({n:"Día "+d,t:"<b>Acelerador · "+min+" min de sol</b>Aplica, "+min+" min sin protector, refresca, FPS Drops, y ~1 h de sol. Cierra con After Sun."});
        min+=5;
      }else{
        before.push({n:"Día "+d,t:"<b>Acelerador + Profundizador</b>Ya tienes base: suma el Cacao Tanning Oil para llevar el tono más profundo. Misma mecánica de ciclos."});
      }
    }
    if(prepDays>6) before.push({n:"Día 7+",t:"<b>Mantén el ciclo</b>Repite hasta el día de tu viaje. Hidrata siempre después del sol.",rest:true});

    if(tripDays>0){
      during.push({n:"Día 1", t: prepDays>0
        ? "<b>Llegas con base</b>Aplica bronceador, 10 min de sol, FPS Drops y sesiones de ~1 h. Evita el sol entre 1 y 4 pm."
        : "<b>Empiezas desde cero</b>Tu piel apenas va a activar melanina: 10 min sin protector, luego FPS y sombra. No fuerces el primer día."});
      if(tripDays>=2){
        during.push({n:tripDays===2?"Día 2":"Días 2–"+tripDays,
          t:"<b>Repite el ciclo</b>Sube 5 minutos la exposición inicial cada día. Reaplica FPS cada 2 h o después de nadar, y After Sun cada noche."});
      }
      if(tripDays>=5){
        during.push({n:"Todos",t:"<b>Cuida el resultado</b>Hidrata a diario: la piel hidratada mantiene el bronceado más tiempo y se quema menos.",rest:true});
      }
    }
    return {before:before,during:during};
  }

  function renderDays(prep,trip){
    var p=plan(prep,trip), html="";
    function block(label,arr){
      if(!arr.length) return "";
      var s='<p class="daygroup">'+label+'</p>';
      s+=arr.map(function(d){
        return '<div class="day'+(d.rest?" rest":"")+'"><span class="dn">'+d.n+'</span><span class="dt">'+d.t+'</span></div>';
      }).join("");
      return s;
    }
    html+=block("Antes de irte · "+prep+(prep===1?" día":" días"),p.before);
    html+=block("En tu viaje · "+trip+(trip===1?" día":" días"),p.during);
    document.getElementById("days").innerHTML=html;
  }

  var routinePlanned=false;
  function showRoutine(){
    var el=document.getElementById("vrut"); if(!el) return;
    var q=routinePlanned?quote(state):null;
    if(!q){ el.hidden=true; el.innerHTML=""; return; }
    var names=OILS.filter(function(o){return state.oils.indexOf(o.id)>-1}).map(function(o){return o.name});
    if(state.fps) names.push(FPS.name);
    if(state.after) names.push(AFTER.name);
    var save=Math.round((q.list-q.total)*100)/100;
    el.innerHTML='<span class="vr-k">Tu rutina</span>'
      +'<span class="vr-n">'+names.join(" + ")+'</span>'
      +'<span class="vr-p">'+(save>0.5?'<s>'+SHORT(q.list)+'</s> ':'')+'<b>'+SHORT(q.total)+'</b>'
      +(q.pct>0?' <em>'+q.pct+'% OFF</em>':(save>0.5?' <em>Ahorras '+SHORT(save)+'</em>':''))+'</span>';
    el.hidden=false;
  }

  /* Selecciona sólo lo que exista y esté disponible */
  function pickOils(wanted){
    var ok=wanted.filter(function(id){
      return OILS.some(function(o){return o.id===id&&o.available!==false});
    });
    return ok.length?ok:state.oils;
  }

  document.getElementById("calcBtn").addEventListener("click",function(){
    var v=document.getElementById("tripDate").value;
    var tripLen=Math.max(1,Math.min(60,parseInt(document.getElementById("tripLen").value,10)||7));
    var verdict=document.getElementById("verdict");
    if(!v){ document.getElementById("tripDate").focus(); return; }
    var today=new Date(); today.setHours(0,0,0,0);
    var trip=new Date(v+"T00:00:00");
    var dias=Math.round((trip-today)/86400000);
    var prep=dias-SHIP_MAX;
    var big=document.getElementById("vbig"), msg=document.getElementById("vmsg"),
        ship=document.getElementById("vship"), card=document.getElementById("vcard"),
        days=document.getElementById("days"), apply=document.getElementById("applyBtn");

    card.classList.remove("warn"); apply.hidden=true; days.innerHTML="";
    var rut=document.getElementById("vrut"); if(rut){ rut.hidden=true; rut.innerHTML=""; }
    routinePlanned=false;
    var viaje=tripLen+(tripLen===1?" día":" días");

    if(dias<0){
      big.textContent="—";
      msg.innerHTML="Esa fecha ya pasó. Pon la fecha de tu próximo viaje.";
      ship.textContent="";
    } else {
      /* Nunca decirle que "ya no alcanza": eso la manda a no comprar. Si el viaje es
         pronto, la rutina se hace alla y el aceite correcto hace rendir cada sesion. */
      if(prep<=0){
        big.textContent=dias+(dias===1?" día":" días");
        msg.innerHTML="<b>¡Aún estás a tiempo!</b> Pídelo hoy y haz tu rutina durante tus "+viaje+" de viaje: acelerador y profundizador juntos desde la primera sesión, para que cada día al sol rinda.";
        ship.textContent=SHOW_SHIP?("Envío gratis · "+SHIP_MIN+" a "+SHIP_MAX+" días hábiles."):"Envío gratis en todo tu pedido.";
        renderDays(0,tripLen);
      } else {
        big.textContent=prep+(prep===1?" día":" días");
        if(prep<=3) msg.innerHTML="<b>Te da tiempo.</b> Con "+prep+" día"+(prep===1?"":"s")+" de preparación y "+viaje+" de viaje, arranca fuerte: acelerador y profundizador desde el día 1.";
        else msg.innerHTML="<b>Te alcanza para la rutina completa.</b> "+prep+" días para preparar tu piel y "+viaje+" de viaje para llevar el tono más lejos.";
        ship.textContent=SHOW_SHIP?("Ya contamos "+SHIP_MAX+" días hábiles de envío. Entre más pronto pidas, más ciclos alcanzas."):"Entre más pronto pidas, más ciclos alcanzas antes de irte.";
        renderDays(prep,tripLen);
      }
      /* La rutina que armamos incluye FPS y After Sun (protege el bronceado y es la de
         mayor descuento). Se muestra aqui mismo: en los pasos 2 y 3 quedaba fuera de vista. */
      state.oils=pickOils(["carrot","cacao"]); state.fps=true; state.after=true;
      routinePlanned=true; render();
      apply.hidden=false;
    }
    verdict.classList.add("show");
  });

  document.getElementById("applyBtn").addEventListener("click",function(){
    /* El planificador ahora va ARRIBA del paso 1: se baja a la seleccion ya aplicada. */
    var oils=document.getElementById("oils");
    if(!oils) return;
    var head=oils.previousElementSibling||oils;
    var top=head.getBoundingClientRect().top+window.pageYOffset-70;
    window.scrollTo({top:Math.max(0,top),behavior:"smooth"});
  });

  document.addEventListener("click",function(e){
    var t=e.target.closest("[data-hero]");
    if(t){ state.hero=t.getAttribute("data-hero"); renderGallery(); return; }

    var o=e.target.closest("[data-oil]");
    if(o){
      var id=o.getAttribute("data-oil"), i=state.oils.indexOf(id);
      if(i>-1){ if(state.oils.length>1) state.oils.splice(i,1); }  /* mínimo uno */
      else { state.oils.push(id); state.hero=id; }
      render(); return;
    }
    var a=e.target.closest("[data-add]");
    if(a){
      var k=a.getAttribute("data-add");
      state[k]=!state[k];
      if(state[k]) state.hero=k;
      render(); return;
    }
  });
  document.addEventListener("keydown",function(e){
    if(e.key!=="Enter"&&e.key!==" ")return;
    var t=e.target.closest("[data-oil],[data-add]"); if(!t)return;
    e.preventDefault(); t.click();
  });

  render();
})();
